import HistoricoModificacao from '@/components/form/historico-modificacao'

import ListaBoletos from '@/components/form/boleto/listar-boletos'

import ProductDashboard from '../producto-dashboard'

import { PageLayout } from '@/layouts'
import { useFetchApuracaoByIdProduct } from '../../services/useFetchApuracaoByIdProduct'
import { Loader2 } from 'lucide-react'

import { useApuracaoSelecionada } from '../../hooks/seApuracaoSelecionada'
import { useEffect } from 'react'
import { ProdutosStatus } from '@/lib/enums'
import { Product } from '../../state/selectProduct'
import { useCurrentUser } from '@/features/auth/state/auth'
import ResumoFCVS from '../FCVS/resumos.-fcvs'
import FCVSApp from '../FCVS/fcvs'

type FCVSProps = {
  cnpj?: string
  product: Product
}

export default function FCVS({ cnpj, product }: FCVSProps) {

  const { data: apuracoes = [], isLoading } = useFetchApuracaoByIdProduct(product?.id ?? '')
  const { apuracaoSelecionada, setApuracaoSelecionada } = useApuracaoSelecionada()
  const user = useCurrentUser()

  useEffect(() => {
    if (apuracoes.length > 0 && !apuracaoSelecionada) {
      setApuracaoSelecionada(apuracoes[0])
    }
  }, [apuracoes])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-96 z-50">
        <Loader2 className="h-10 w-10 animate-spin text-primary" />
      </div>
    )
  }

  if (!apuracaoSelecionada) {
    return <p>Nenhuma apuração encontrada.</p>
  }
  
  return (
    <PageLayout title="FCVS" showSidebarTrigger={false}>
      <ResumoFCVS id_apuracao={apuracaoSelecionada.id} />
      <ProductDashboard
        clientInfo={{
          parceiro: product.parceiro,
          empresa: product.empresa,
          nomeAnalista: product.nomeAnalista,
          status: ProdutosStatus[product.status] ?? product.status
        }}
        cnpj={cnpj ?? ''}
        productId={product.id}
        type="FCVS"
        apuracoes={apuracoes}
        selectedApuracao={apuracaoSelecionada}
      />

      {user?.typeUser === 'ADMIN' && <FCVSApp />}

      <HistoricoModificacao type="PIS_COFINS_MONOFASICO_PARA_SN" productId={product.id} />
      <ListaBoletos cnpj={cnpj} />
    </PageLayout>
  )
}
